import SecureLs from "secure-ls"
import * as commonController from "../controllers/commonController"
import * as base_url from "../shared/base_url"
// // -- import * as _ from "lodash-es"
let _base_mixin = {
  data() {
    return {
      ls: new SecureLs({
        encodingType: "aes",
        isCompression: true
      }),
      base_url: base_url.base_url,
      main_content_height: 0
    }
  },
  computed: {
    lang: function () {
      let locale = this.$i18n.locale
      if (locale === "zh-CN") return "中文"
      if (locale === "en") return "English"
    }
  },
  async created() {
    let this_ = this

    let plant_idx = localStorage.getItem("plant_idx")
    if (plant_idx) this_.plant_idx = plant_idx
  },
  methods: {
    msgModal(msg) {
      const h = this.$createElement
      return this.$bvModal.msgBoxConfirm([h("h6", [msg])], {
        title: "提示",
        headerBgVariant: "danger",
        okVariant: "danger",
        okTitle: "确定",
        cancelTitle: "取消",
        footerClass: "p-2",
        hideHeaderClose: false
      })
    },

    msgToasts(msg, _variant, _time, UseHTML, customClass) {
      _variant = _variant == null ? "info" : _variant
      let _title = "",
        _msg = ""
      if (_variant == "success") {
        _title = msg
      } else if (_variant == "warning") {
        _title = "警告"
        _msg = msg
      } else if (_variant == "info") {
        _title = "消息"
        _msg = msg
      } else if (_variant == "error") {
        _title = "错误"
        _msg = msg
      }
      ////element提示
      let _notify = {
        title: _title,
        message: _msg,
        type: _variant,
        customClass: customClass
      }
      if (_time != null) {
        _notify["duration"] = _time
      }
      if (UseHTML != null) {
        _notify["dangerouslyUseHTMLString"] = UseHTML
      }
      this.$notify(_notify)
    },
    formatDate(_dateTime, format_type) {
      return commonController.formatDate(_dateTime, format_type)
    }
  }
}
export default _base_mixin
